"use client"

import { ContactForm } from "@/components/contact-form"

export function ContactSection() {
  return (
    <div className="w-full">
      <ContactForm />
    </div>
  )
}
